"use client";

import { HealthSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedHealthSection from "../Components/GeneratedHealthSection";

const Health: FC<HealthSectionProps> = (props) => {
  return <GeneratedHealthSection {...props} />;
};

export default Health;
